import * as Forms      from '../components/forms';
import * as User       from '../user';
import { Block }       from 'framework7-react';
import { compose }     from 'redux';
import { connect }     from 'react-redux';
import { PageContent } from 'framework7-react';
import Navbar          from '../components/navbar';
import React           from 'react';
import zxcvbn          from 'zxcvbn';


const errorList = [
  'Your new password is not strong enough.',
  'A weak password could allow someone to hack into your account.',
  'Try a longer password, 10 or more characters.',
  'Use both upper and lower case letters, numbers, and special characters.'
];


function ChangePasswordPage({ navigateBackTo, isPasswordless, isSalesforce, updateProfile }) {
  async function changePassword({ newPassword, currentPassword, email }) {
    await updateProfile({ password: newPassword, currentPassword, email }, { showDefaultErrorUI: false });
    navigateBackTo('../');
  }

  const title = isPasswordless ? 'Set your password' : 'Change your password';
  return (
    <React.Fragment>
      <Navbar title={title}/>
      <PageContent>
        <PasswordFormDescription/>
        <Forms.Form save={changePassword} validate={validate.bind(null, { isSalesforce, isPasswordless })}>
          {isPasswordless && <SetEmailAndPasswordForm/>}
          {!isPasswordless && <NewPasswordForm isSalesforce={isSalesforce}/>}
        </Forms.Form>
      </PageContent>
    </React.Fragment>
  );
}


function PasswordFormDescription() {
  return (
    <Block>
      <p>Choose a strong password that is easy to remember. We recommend passwords that have 10 or more characters. We recommend passwords that include capital and lower case letters, numbers, and special characters. Do not use the same password as any other service or app.</p>
    </Block>
  );
}


function validate({ isSalesforce, isPasswordless }, fields) {
  if (isPasswordless && (!fields.email || !fields.newPassword || !fields.confirmNewPassword))
    throw Error('Please, fill out the fields');
  else if (!isPasswordless && ((!isSalesforce && !fields.currentPassword) || !fields.newPassword || !fields.confirmNewPassword))
    throw Error('Please, fill out the fields');

  if (fields.newPassword !== fields.confirmNewPassword)
    throw Error('New Password and Confirm New Password should match');

  if (zxcvbn(fields.newPassword).score < 2)
    throw new Forms.FormError('Weak Password', errorList);
}


function NewPasswordForm({ isSalesforce, ...form }) {
  return (
    <div className="list block">
      <ul>
        <Forms.Error {...form}/>
        {!isSalesforce && (<Forms.Input {...form} type="password" label="Current Password" name="currentPassword"/>)}
        <Forms.PasswordStrengthInput {...form} label="New Password" name="newPassword"/>
        <Forms.PasswordStrengthInput {...form} label="Confirm New Password" name="confirmNewPassword"/>
        <Forms.Button {...form} label="Change Password"/>
      </ul>
    </div>
  );
}

function SetEmailAndPasswordForm({ ...form }) {
  return (
    <div className="list block">
      <ul>
        <Forms.Error {...form}/>
        <Forms.Input {...form} type="email" label="Email" name="email"/>
        <Forms.PasswordStrengthInput {...form} label="Password" name="newPassword"/>
        <Forms.PasswordStrengthInput {...form} label="Confirm Password" name="confirmNewPassword"/>
        <Forms.Button {...form} label="Set password"/>
      </ul>
    </div>
  );
}

export default connect(
  state => ({
    profile:        User.getProfile(state),
    isSalesforce:   User.isSalesforce(state),
    isPasswordless: User.isPasswordless(state)
  }),
  (dispatch, { navigateBackTo }) => ({
    updateProfile: compose(dispatch, User.updateProfile),
    navigateBackTo
  })
)(ChangePasswordPage);
